import { Link } from "react-router-dom";
import { CalendarDays } from "lucide-react";
import { mediaUrl, formatWIT, CONTENT_TYPE_LABELS } from "@/lib/appApi";

const FALLBACK = "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=800&q=80";

export function DemoBadge({ article }) {
  if (!article?.is_demo) return null;
  return (
    <span className="inline-block bg-yellow-100 text-yellow-800 border border-yellow-300 text-[10px] font-bold px-2 py-0.5 rounded uppercase tracking-wide" data-testid="demo-badge">
      Konten Demo — Bukan Berita Resmi
    </span>
  );
}

export default function NewsCard({ article, unitMap = {}, size = "md" }) {
  const unit = unitMap[article.responsible_unit];
  const img = article.featured_media_url ? mediaUrl(article.featured_media_url) : FALLBACK;
  return (
    <Link to={`/berita/${article.slug}`} data-testid={`news-card-${article.slug}`}
      className="group block bg-white rounded-lg border border-gray-200 overflow-hidden hover:shadow-lg hover:-translate-y-1 transition-[transform,box-shadow] duration-200 focus:outline-none focus:ring-2 focus:ring-dlh-orange">
      <div className="relative overflow-hidden aspect-[16/10] bg-gray-100">
        <img src={img} alt={article.featured_alt || article.title} loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
        <span className="absolute top-3 left-3 bg-dlh-orange text-white text-[11px] font-bold px-2.5 py-1 rounded uppercase tracking-wide shadow">
          {CONTENT_TYPE_LABELS[article.content_type] || "Berita"}
        </span>
      </div>
      <div className="p-4">
        {article.is_demo && <div className="mb-2"><DemoBadge article={article} /></div>}
        {unit && <div className="text-xs font-semibold text-dlh-greenMid mb-1.5 leading-snug">{unit.short_name}</div>}
        <h3 className={`font-serif font-bold text-dlh-green leading-snug group-hover:text-dlh-orange transition-colors ${size === "lg" ? "text-2xl" : "text-lg"}`}>
          {article.title}
        </h3>
        <p className="mt-2 text-sm text-gray-600 line-clamp-2 leading-relaxed">{article.summary}</p>
        <div className="mt-3 flex items-center gap-1.5 text-xs text-gray-500">
          <CalendarDays className="h-3.5 w-3.5" /> {formatWIT(article.published_at)}
        </div>
      </div>
    </Link>
  );
}
